import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import "intl";
import { IntlProvider, addLocaleData } from "react-intl";

import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import pt from "react-intl/locale-data/pt";
import zh from "react-intl/locale-data/zh";

import { connect } from "react-redux";
import ConnectedRouter from "ducks/router/ConnectedRouter";
import { PublicRoute, PrivateRoute } from "components";
import { getDashboard } from "ducks/user/actions";
import { localStorage } from "utils/storage";
import { ACCESS_TOKEN } from "utils/http";
import {
  LoginAdded,
  Login,
  LoginAuth,
  Invest,
  Settings,
  Dashboard,
  Withdraw,
  Notifications,
  Disclosures
} from "containers";
import IntlMessages from "../../config/messages";
import "./App.scss";

addLocaleData(en);
addLocaleData(es);
addLocaleData(pt);
addLocaleData(zh);

class App extends Component {
  componentDidMount() {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    if (accessToken) {
      this.props.getDashboard();
    }
  }

  render() {
    const { history, user } = this.props;
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    const lang = user.lang.toLowerCase();

    return (
      <IntlProvider locale={user.lang} messages={IntlMessages[user.lang]}>
        <ConnectedRouter history={history}>
          <div className="App">
            <Switch>
              <PublicRoute path="/login/" component={LoginAdded} />
              <PublicRoute path={`/${lang}/login/`} component={LoginAdded} />
              <PublicRoute path="/auth/" component={LoginAuth} />
              <PublicRoute exact={true} path={`/${lang}/`} component={Login} />
              <PrivateRoute exact={true} path={`/${lang}/settings/`} component={Settings} />
              <PrivateRoute exact={true} path={`/${lang}/dashboard/`} component={Dashboard} />
              <PrivateRoute exact={true} path={`/${lang}/invest/`} component={Invest} />
              <PrivateRoute exact={true} path={`/${lang}/withdraw/`} component={Withdraw} />
              <PrivateRoute exact={true} path={`/${lang}/notifications/`} component={Notifications} />
              <PrivateRoute exact={true} path={`/${lang}/disclosures/`} component={Disclosures} />
              <Redirect to={accessToken ? `/${user.lang.toLowerCase()}/dashboard/` : `/${user.lang.toLowerCase()}/`} />
            </Switch>
          </div>
        </ConnectedRouter>
      </IntlProvider>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps, { getDashboard })(App);



// WEBPACK FOOTER //
// ./src/containers/app/App.js